import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';
import { Router, RouterModule, Routes, Route, } from '@angular/router';

import { CommonService } from '../Abstract/commons.service';
import { ConfigService } from '../Abstract/config.service';
import { SecurityService } from '../Security/security.service';
import { HomeComponent } from '../../Menus/Home/home.component';
import { LogService } from '../Abstract/log.service';
import { WebXmlComponent } from './webxml.component';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { OnboardEditComponent } from '../../Menus/Onboard/onboard.component';
import { ChangePasswordComponent } from '../../Core/Login/changePassword.component';
import { ContactUsComponent } from '../../Menus/Onboard/ContactUs/contactUs.component';
import { InviteComponent } from 'app/Menus/Invite/invite.component';
import { UserListComponent } from 'app/Menus/UserList/userList.component';
import { WelcomeScreenComponent } from 'app/Menus/WelcomeScreen/welcomeScreen.component';
import { FullComponent } from '@core/Abstract/layouts/full/full.component';
import { ValidateCustomerComponent } from 'app/Menus/ValidateCustomer/validateCustomer.component';


@Injectable()

export class RoutesService extends SecurityService{


     constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService, private webxml:WebXmlComponent ) {
        super(http,configService,eventsEmitterService, router ,logger);
    }

    getRoutesForUser(langid): Observable<any>{

        let serviceUrl = this.baseUrl + 'RoutesService/getRoutesByPerId?langId=' + langid;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /*
     * Called after successful login 
     * and every refresh / URL type
     */
    public getRoutes(url : string){
        this.getRoutesForUser(localStorage.getItem('langId')).subscribe(
                data => {
                    //Get initial Route configurations
                    let routerConfig = this.router.config;
                    let childRoutes: Routes = [];

                    if(this.configService.getIsLogoutExternal()){
                        routerConfig.forEach((element, index) => {
                            if(element.path == "login"){
                                routerConfig.splice(index, 1);
                            }
                        });
                    }else{
                         routerConfig.forEach((element, index) => {
                            if(element.path == "sso"){
                                routerConfig.splice(index, 1);
                            }
                        });
                    }

                    this.logger.log(routerConfig);
                    //Add a Route item for every menu in DB
                    for(let i in data){
                        let routerItem:Route = {};
                        //if a Component String is matching get it's Object
                        routerItem.component = this.webxml.getComponent(data[i].component);
                        routerItem.path = data[i].path;
                        routerItem.data = {
                            lang1 : data[i].lang1,
                            lang2 : data[i].lang2
                        }
                        childRoutes.push(routerItem);
                    }

                    //Add Generic pages available to all Users

                    //Home Page
                    let routerHome:Route = {};
                    routerHome.component = HomeComponent;
                    routerHome.path = 'home';
                    routerHome.data = {
                        lang1 : 'Αρχική',
                        lang2 : 'Home'
                    }
                    childRoutes.push(routerHome);

                    //test onboard
                    let onboard:Route = {};
                    onboard.component = OnboardEditComponent;
                    onboard.path = 'onboard';
                    onboard.data = {
                        lang1 : 'Onboarding',
                        lang2 : 'Onboarding'
                    }
                    childRoutes.push(onboard);

                    let contact:Route = {};
                    contact.component = ContactUsComponent;
                    contact.path = 'contact';
                    contact.data = {
                        lang1 : 'Contact',
                        lang2 : 'Contact'
                    }
                    childRoutes.push(contact);

                    let userList:Route = {};
                    userList.component = UserListComponent;
                    userList.path = 'userList';
                    userList.data = {
                        lang1 : 'UserList',
                        lang2 : 'UserList'
                    }
                    childRoutes.push(userList);

                    let welcomeScreen:Route = {};
                    welcomeScreen.component = WelcomeScreenComponent;
                    welcomeScreen.path = 'welcomeScreen';
                    welcomeScreen.data = {
                        lang1 : 'welcomeScreen',
                        lang2 : 'welcomeScreen'
                    }
                    childRoutes.push(welcomeScreen);

                    let validateCustomer:Route = {};
                    validateCustomer.component = ValidateCustomerComponent;
                    validateCustomer.path = 'validate';
                    validateCustomer.data = {
                        lang1 : 'validateCustomer',
                        lang2 : 'validateCustomer'
                    }
                    childRoutes.push(validateCustomer);

                    let changePassord:Route = {};
                    changePassord.component = ChangePasswordComponent;
                    changePassord.path = 'changePassword';
                    changePassord.data = {
                        lang1 : 'ChangePassord',
                        lang2 : 'ChangePassord'
                    }
                    childRoutes.push(changePassord);

                    //invite
                    let invite:Route = {};
                    invite.component = InviteComponent;
                    invite.path = 'invite';
                    invite.data = {
                        lang1 : 'Invite',
                        lang2 : 'Invite'
                    }
                    childRoutes.push(invite);
                    
                    //Add Layout template used by every menu 
                    //and the above created children
                    const routerConst = {
                        path: 'menu',
                        component: FullComponent,
                        data: {
                            lang1 : 'Λεπτομέρειες',
                            lang2 : 'Details'
                        },
                        children: childRoutes
                    };
                    //Reinitialise Routes
                    this.logger.log(routerConst)
                    routerConfig.unshift(routerConst);
                    this.router.resetConfig(routerConfig);



                    /*
                     * Handling refresh / URL typing
                     */
                    //clear url of parameters
                    let withoutparams = url.split(';');
                    url = withoutparams[0];

                    let jsio:any = {};

                    for (let index = 1; index < withoutparams.length; index++) {
                        let params = withoutparams[index].split('=');
                        if(params.length > 1){
                            jsio[ params[0].toString() ] = params[1].toString();
                        }
                        
                    }
                   


                    //handle randonmness of "/" starting
                    if (url.indexOf('/') == 0) {
                        url = url.substr(1, url.length);
                    }
                    this.logger.log("typed url: " + url);

                    
                    if (url.indexOf('/') >= 0 && url.indexOf('menu') == 0) {
                        let URLarray = url.split('/');
                        if (URLarray.length > 1) {
                            let menuId = URLarray[1];

                            //create string of menuIds to check against typed url
                            let menuListStr = "##";
                            routerConfig.forEach(element => {
                                if (element.children) {
                                    element.children.forEach(child => {
                                        menuListStr += child.path + '##'// delimiter
                                    })
                                }
                            });
                            //this.logger.log(menuListStr)
                            //this.logger.log(menuId)
                            if (menuListStr.indexOf(menuId) > 0) {
                                //only accept urls after 1 slash
                                url = URLarray[0] + '/' + URLarray[1]
                                this.logger.log('final url:' + url)

                                
                                //trick to handle refresh 
                                //(Router doesnt refresh page if navigated to same exact URL)
                                //so dummy params are added/removed to detect URL change
                                if (withoutparams.length == 1 ) {
                                    this.router.navigate([url, {refresh : 'refresh'}]);
                                } else {
                                    let refreshFound:boolean = false;
                                    Object.keys(jsio).forEach(element => {
                                        if(jsio[element] == 'refresh'){
                                            refreshFound = true;
                                        }
                                    });

                                    if(refreshFound){
                                        delete jsio.refresh;
                                    } else {
                                        jsio.refresh = 'refresh';
                                    }
                                    

                                    this.router.navigate([url,jsio]);
                                }

                            //All check failures redirect to home    
                            } else {
                                this.router.navigateByUrl('menu/home');
                            }
                        } else {
                            this.router.navigateByUrl('menu/home');
                        }

                    } else {
                        this.router.navigateByUrl('menu/home');
                    }
                },
                error => {
                    this.logger.log("Route initialization service has failed");
                    this.goToLogin("routes","fail");
                }
            );
        
    }


}
